import React, { useState, useRef, useEffect } from "react";
import "./workshop.scss";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import { EditorState, convertFromRaw, convertToRaw } from "draft-js";
// import { Editor } from "react-draft-wysiwyg";
import {
  CancelButton,
  IconButton,
  LoadingButton,
  PrimaryButton,
} from "../../custom_components/customButton";
import { RiImageAddFill, RiCloseCircleFill } from "react-icons/ri";
import { IoMdAddCircleOutline, IoMdCloseCircle } from "react-icons/io";
import { FaUpload } from "react-icons/fa";
import { Col, Input, Row, Select, Checkbox, TimePicker } from "antd";
import { colorScheme } from "../../contants/variables";
// import ArticlePreviewModal from "../../custom_components/articlePreviewModal";
// import {
//   addArticle,
//   editArticle,
//   fetchSections,
// } from "../../stores/api_calls/articles";
import { error, success } from "../../contants/snackbars";
import { uploadImage } from "../../stores/api_calls/upload";
import { useLocation, useNavigate } from "react-router-dom";
import Kjur from "../../stores/utils/jwt";
// import { validateArticleForm } from "../../stores/helpers/articleFormValidation";
import {
  addCarWorkShop,
  editCarWorkShop,
  fetchCarWorkshop,
  fetchBrands,
  fetchCategories,
} from "../../stores/api_calls/car-workshop";
import moment from "moment";
import UploadWorkshopImages from "./UploadWorkshopImages";

// const ImageUploadComponent = (props) => {
//   const { onChange } = props;
//   const fileUploader = useRef(null);

//   const uploadImageCallBack = (link) => {
//     onChange(link, "auto", "100%", "uploaded image");
//   };

//   const onSelectFile = (e) => {
//     const file = e.target.files[0];
//     // const localUrl = URL.createObjectURL(file)

//     const upload = uploadImage(file);

//     upload
//       .then((res) => {
//         if (res.data.success) {
//           console.log(res.data.data);
//           const url = res.data.data.metadata.image_url;
//           uploadImageCallBack(url);
//         }
//       })
//       .catch((e) => {
//         error(
//           `Opps! ${e.response.data.server_response} . Upload Failed. Please try again`
//         );
//       });
//   };

//   const handleOpenGallery = (event) => {
//     fileUploader.current.click();
//   };

//   return (
//     <div>
//       <div className="icon-button-div">
//         <IconButton
//           className="icon-button upload"
//           tootTipTitle="Upload Image"
//           Icon={<RiImageAddFill />}
//           onClick={handleOpenGallery}
//         />
//       </div>

//       <input
//         ref={fileUploader}
//         hidden
//         type="file"
//         name="image-event"
//         id="image-event"
//         accept="image/*"
//         onChange={onSelectFile}
//       />
//     </div>
//   );
// };

const CarWorkshopForm = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const [isEdit, setIsEdit] = useState(false);
  const [form, setForm] = useState({
    imagesIds: [],
    imageUrls: [],
    name: "",
    address: "",
    email: "",
    contact: "",
    website: "",
    facebook: "",
    opening_time: "",
    closing_time: "",
    categories: [],
    brands: [],
    description: "",
    open_till_late: false,
    open_on_sundays: false,
    customer_lounge: false,
    accepts_credit_card: false,
    installment_plan: false,
    door_step_service: false,
    workshop_logo: null,
    workshop_logo_url: null,
  });

  const [requestLoading, setRequestLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 100,
    defaultPageSize: 100,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30"],
  });
  const [workshop, setWorkshop] = useState({});
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const fileUploader = useRef(null);
  const [selectedLogo, setSelectedLogo] = useState({ file: null, url: "" });

  useEffect(() => {
    if (location.pathname.includes("/edit")) {
      setIsEdit(true);
      const parsedData = Kjur.decode(params.get("token"));
      // console.log("PARAMS" , parsedData)
      setRequestLoading(true)

      const getWorkshop = fetchCarWorkshop(parsedData?.id);
      
      getWorkshop.then((res) => {
        
        if(res.data.success){
          setWorkshop(res.data.data)
          setRequestLoading(false)
        }
      }).catch((e)=>console.log(e))
    }
  }, []);

  useEffect(()=>{
          
    if(isEdit) {
        const parsedData = Kjur.decode(params.get('token'))
        console.log(workshop);

        setForm({
          ...form,
          id: parsedData.id,
          // imagesIds: parsedData.workshop_image_id,
          imageUrls: parsedData.workshop_image_urls,
          name: parsedData.car_workshop_name,
          address: parsedData.car_workshop_address,
          email: parsedData.email,
          contact: parsedData.contact_numbers,
          website: parsedData.website,
          facebook: parsedData.facebook,
          opening_time: parsedData.operating_hours.opening_time,
          closing_time: parsedData.operating_hours.closing_time,
          categories: parsedData.categories,
          brands: parsedData.brands,
          description: parsedData.description,
          open_till_late: parsedData.open_till_late ?? false,
          open_on_sundays: parsedData.open_on_sundays ?? false,
          customer_lounge: parsedData.customer_lounge ?? false,
          accepts_credit_card: parsedData.accepts_credit_card ?? false,
          installment_plan: parsedData.installment_plan ?? false,
          door_step_service: parsedData.door_step_service ?? false,
          workshop_logo: parsedData.workshop_logo ?? null,
          workshop_logo_url: parsedData.workshop_logo ?? null,
        })
    }
  }, [isEdit])

  const onSubmit = async () => {
    setRequestLoading(true);

    await handleUpload(selectedLogo, "workshop_logo");

    const imagesIds = isEdit
      ? form.imageUrls.map((img) => img._id["$oid"])
      : [];

    if (selectedFiles.length) {
      selectedFiles.forEach((file, index) => {
        const upload = uploadImage(file, index + 1);

        upload.then((res) => {
          if (res.data.success) {
            // imagesIds = [...imagesIds, res.data.data._id];
            // setForm({
            //   ...form,
            //   imagesIds: [...(form.imagesIds || []), res.data.data._id],
            // });

            imagesIds.push(res.data.data._id);

            if (imagesIds.length - form.imageUrls.length === selectedFiles.length) {
              if(!isEdit) {
                handleAddCarWorkShop(imagesIds);
              }else {
                handleUpdateCarWorkShop(imagesIds);
              }
              
            }
          }
        });
      });
    } else {
      if(!isEdit) {
        handleAddCarWorkShop(imagesIds);
      }else {
        handleUpdateCarWorkShop(imagesIds);
      }
    }
  };

  const handleAddCarWorkShop = (imagesIds) => {
    const createCarWorkShop = addCarWorkShop({ ...form, imagesIds });
    createCarWorkShop
      .then((res) => {
        if (res.data.success) {
          console.log(res.data);
          success("New car workshop has been added successfully!");
          setRequestLoading(false);
          navigate("../car-workshops", { replace: true });
        }
      })
      .catch((e) => {
        setForm({ ...form, imagesIds: [] });
        error("Failed to add car workshop");
        console.log("error");
        setRequestLoading(false);
      });
  };
  
  const handleUpdateCarWorkShop = (imagesIds) => {
    console.log(form);
    const updateCarWorkShop = editCarWorkShop({ ...form, imagesIds });
    updateCarWorkShop
      .then((res) => {
        if (res.data.success) {
          console.log(res.data);
          success("Car workshop has been updated successfully!");
          setRequestLoading(false);
          navigate("../car-workshops", { replace: true });
        }
      })
      .catch((e) => {
        setForm({ ...form, imagesIds: [] });
        error("Failed to add car workshop");
        console.log("error");
        setRequestLoading(false);
      });
  };

  const onCheckboxChange = (name) => {
    setForm({ ...form, [name]: !form[name] });
  };

  const handleFieldChange = (name, e) => {
    setForm({ ...form, [name]: e.target.value });
  };

  const handleOnChangeOperatingHours = (time, timeString) => {
    setForm({
      ...form,
      opening_time: timeString[0],
      closing_time: timeString[1],
    });
  };

  const handleChangeCategory = (value) => {
    setForm({ ...form, categories: value });
  };

  const handleChangeBrand = (value) => {
    setForm({ ...form, brands: value });
  };

  useEffect(() => {
    handleFetchCategories();
    handleFetchBrands();
  }, []);

  const handleFetchCategories = () => {
    const filter = {
      keyword: "",
      page: pagination.current,
      limit: pagination.pageSize,
    };
    const getCategories = fetchCategories(filter);

    getCategories
      .then((res) => {
        if (res.data.success) {
          const transformData = res.data.data.map((item) => ({
            ...item,
            label: item.name,
            value: item.name,
          }));
          setCategories(transformData);
        }
      })
      .catch((e) => {
        error(
          `Opps! ${e.response.data.server_response} . Fetched Failed. Please try again later`
        );
      });
  };

  const handleFetchBrands = () => {
    const filter = {
      keyword: "",
      page: pagination.current,
      limit: pagination.pageSize,
    };
    const getBrands = fetchBrands(filter);

    getBrands
      .then((res) => {
        if (res.data.success) {
          const transformData = res.data.data.map((item) => ({
            ...item,
            label: item.name,
            value: item.name,
          }));
          setBrands(transformData);
        }
      })
      .catch((e) => {
        error(
          `Opps! ${e.response.data.server_response} . Fetched Failed. Please try again later`
        );
      });
  };

  const resetForm = () => {
    setForm({ imagesIds: [] });
  };

  const handleOpenGallery = () => {
    fileUploader.current.click();
  };

  const handleImageChange = (e) => {
    setSelectedLogo({ ...selectedLogo, file: null, url: "" });

    if (e.target.files) {
      const file = e.target.files[0];
      const url = URL.createObjectURL(file);
      setSelectedLogo({ ...selectedLogo, file: file, url: url });
      setForm({ ...form, workshop_logo_url: url });
    }
  };

  const handleUpload = async (file, key) => {
    if (file.file) {
      try {
        const res = await uploadImage(file.file);
        if (res.data.success) {
          form[key] = res?.data?.data?.metadata?.image_url || null;
          // console.log(logoUrl);
          // setForm({ ...form, workshop_logo: logoUrl });
        }
      } catch (e) {
        setRequestLoading(false);
        error(e.response.data.server_response);
      }
    }
  };

  return (
    <div className="workshop-form-container">
      <div className={`table-title-icon ${!isEdit ? "add" : "edit"}`}>
        <IoMdAddCircleOutline />
      </div>
      <p className={`table-title-text ${!isEdit ? "add" : "edit"}`}>
        {!isEdit ? "Add Car Workshop" : `Edit Car Workshop`}
      </p>

      <div className="form-container">
        <Row gutter={[15, 15]}>
          <Col span={24} lg={16}>
            <div className="form-fields">
              <p className="form-field-label">
                Car Workshop Name <span>*</span> :{" "}
              </p>
              <Input
                placeholder="Car Workshop Name"
                value={form.name}
                onChange={(text) => handleFieldChange("name", text)}
              />
            </div>

            <div className="form-fields">
              <p className="form-field-label">
                Address <span>*</span> :{" "}
              </p>
              <Input
                placeholder="Address"
                value={form.address}
                onChange={(text) => handleFieldChange("address", text)}
              />
            </div>

            <div className="form-fields">
              <p className="form-field-label">
                Email <span>*</span> :{" "}
              </p>
              <Input
                placeholder="Email"
                value={form.email}
                onChange={(text) => handleFieldChange("email", text)}
              />
            </div>
            <div className="form-fields">
              <p className="form-field-label">
                Contact No <span>*</span> :{" "}
              </p>
              <Input
                placeholder="Contact No"
                value={form.contact}
                onChange={(text) => handleFieldChange("contact", text)}
              />
            </div>
            <div className="form-fields">
              <p className="form-field-label">Website : </p>
              <Input
                placeholder="Website URL"
                value={form.website}
                onChange={(text) => handleFieldChange("website", text)}
              />
            </div>
            <div className="form-fields">
              <p className="form-field-label">Facebook : </p>
              <Input
                placeholder="Facebook"
                value={form.facebook}
                onChange={(text) => handleFieldChange("facebook", text)}
              />
            </div>
            <div className="form-fields">
              <p className="form-field-label">
                Operating hours <span></span> :{" "}
              </p>
              <TimePicker.RangePicker
                use12Hours
                onChange={handleOnChangeOperatingHours}
                style={{ width: "100%" }}
                format="h:mm A"
                value={[
                  form?.opening_time ? moment(form?.opening_time, "h:mm A") : null,
                  form?.closing_time ? moment(form?.closing_time, "h:mm A") : null,
                ]}
              />
            </div>

            <div className="form-fields">
              <p className="form-field-label">
                Categories <span></span> :{" "}
              </p>
              <Select
                mode="multiple"
                style={{
                  width: "100%",
                }}
                placeholder="select categories"
                value={form.categories}
                onChange={handleChangeCategory}
                // optionLabelProp="label"
                // options={categories}
                // optionRender={(option) => <Space>{option.data.name}</Space>}
              >
                {categories.map((c) => (
                  <Select.Option key={c.value} value={c.value}>
                    {c.label}
                  </Select.Option>
                ))}
              </Select>
            </div>

            <div className="form-fields">
              <p className="form-field-label">
                Brands <span></span> :{" "}
              </p>
              <Select
                mode="multiple"
                style={{
                  width: "100%",
                }}
                placeholder="select brands"
                value={form.brands}
                onChange={handleChangeBrand}
                // optionLabelProp="label"
                // options={brands}
                // optionRender={(option) => <Space>{option.data.name}</Space>}
              >
                {brands.map((c) => (
                  <Select.Option key={c.value} value={c.value}>
                    {c.label}
                  </Select.Option>
                ))}
              </Select>
            </div>

            <div className="form-fields">
              <p className="form-field-label">
                Description <span></span> :{" "}
              </p>
              <Input.TextArea
                rows={5}
                value={form.description}
                onChange={(text) => handleFieldChange("description", text)}
              />
            </div>

            <br />
            <p className="permision-label">Other Details : </p>
            <Row gutter={[5, 5]}>
              <Col span={12}>
                <div
                  className="permission-checklist"
                  style={{
                    background: colorScheme.lightgray,
                  }}
                >
                  <Checkbox
                    value={form.open_till_late}
                    checked={form.open_till_late}
                    onChange={(e) => onCheckboxChange("open_till_late", e)}
                  >
                    Open till late
                  </Checkbox>
                </div>
              </Col>
              <Col span={12}>
                <div
                  className="permission-checklist"
                  style={{
                    background: colorScheme.lightgray,
                  }}
                >
                  <Checkbox
                    value={form.open_on_sundays}
                    checked={form.open_on_sundays}
                    onChange={(e) => onCheckboxChange("open_on_sundays", e)}
                  >
                    Open on Sunday
                  </Checkbox>
                </div>
              </Col>
              <Col span={12}>
                <div
                  className="permission-checklist"
                  style={{
                    background: colorScheme.lightgray,
                  }}
                >
                  <Checkbox
                    value={form.customer_lounge}
                    checked={form.customer_lounge}
                    onChange={(e) => onCheckboxChange("customer_lounge", e)}
                  >
                    Customer lounge
                  </Checkbox>
                </div>
              </Col>
              <Col span={12}>
                <div
                  className="permission-checklist"
                  style={{
                    background: colorScheme.lightgray,
                  }}
                >
                  <Checkbox
                    value={form.accepts_credit_card}
                    checked={form.accepts_credit_card}
                    onChange={(e) => onCheckboxChange("accepts_credit_card", e)}
                  >
                    Credit card
                  </Checkbox>
                </div>
              </Col>
              <Col span={12}>
                <div
                  className="permission-checklist"
                  style={{
                    background: colorScheme.lightgray,
                  }}
                >
                  <Checkbox
                    value={form.installment_plan}
                    checked={form.installment_plan}
                    onChange={(e) => onCheckboxChange("installment_plan", e)}
                  >
                    Installment plan
                  </Checkbox>
                </div>
              </Col>
              <Col span={12}>
                <div
                  className="permission-checklist"
                  style={{
                    background: colorScheme.lightgray,
                  }}
                >
                  <Checkbox
                    value={form.door_step_service}
                    checked={form.door_step_service}
                    onChange={(e) => onCheckboxChange("door_step_service", e)}
                  >
                    Door Step Service
                  </Checkbox>
                </div>
              </Col>
            </Row>
          </Col>

          <Col span={24} lg={16}>
            <div className="formModal">
              <div>
                <p style={{ margin: "5px 0x", color: colorScheme.red }}>
                  {`To avoid stretching of image in the website. The image has to be (.jpg , .png) with 1200 pixels width`}
                </p>
              </div>

              <div className="form-container">
                <p className="form-label">Workshop Logo: </p>
                <div className="upload-container" onClick={handleOpenGallery}>
                  <FaUpload />
                  <p className="banner-p">UPLOAD LOGO</p>
                </div>

                <input
                  ref={fileUploader}
                  id="getFile"
                  type="file"
                  hidden
                  onChange={handleImageChange}
                  accept=".png, .jpg, .jpeg"
                />
              </div>

              {form.workshop_logo_url ? (
                <div className="image-preview-container">
                  <div
                    className="removeIcon"
                    onClick={() => setForm({ ...form, workshop_logo_url: "" })}
                  >
                    <RiCloseCircleFill size={24} />
                  </div>
                  <img src={form.workshop_logo_url} />
                </div>
              ):(
                <>{`${form.workshop_logo_url}`}</>
              )}
            </div>
          </Col>

        </Row>
      </div>

      <div
            className='upload-header'
        >
            <div className='header-div'>
                <p className='header-text'>Upload Pictures <span>*</span> :{" "}</p>
                <p className='sub-header-text'>
                Upload requirements: You can upload upto 9 images. Total image file size should not exceed <span style={{color:'red',fontWeight:'bold'}}>10MB</span>. 
                <span style={{color:'red',fontWeight:'bold'}}> Please noted that only PNG & JPG images are allowed. Image dimension (600 width x 400 height)pixels.</span>
                </p>
            </div>
      </div>
      <div className="rental-form-container">
        <UploadWorkshopImages
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          form={form}
          setForm={setForm}
          isEdit={isEdit}
        />
      </div>

      <div className="btn-div">
        <div className="btn">
          {requestLoading ? (
            <LoadingButton />
          ) : (
            <PrimaryButton
              label={isEdit ? "Update Car Workshop" : "Create Car Workshop"}
              color={colorScheme.primary}
              onClick={() => onSubmit()}
              disabled={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CarWorkshopForm;
